import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { markAsDirty, selectShadow } from 'components/shadow_grid/shadows/store/shadows/actions';

import confirm from 'components/confirm';
import Editor from 'components/shadow_grid/shadow/editor';

export function ShadowEditor({
  canExportShadows,
  context,
  markAsDirty,
  selectedShadow,
  selectShadow,
  selectGlobalShadow,
  setDirty: setDirtyTab,
  urls
}) {
  const [dirty, setDirty] = useState();

  React.useEffect(() => {
    function handleDirtyChange(event) {
      if (event.data.type === 'shadow.dirtyChanged') {
        setDirty(event.data.dirty);

        // If the shadow is no longer dirty, then it was saved, meaning the collection is dirty
        if (!event.data.dirty) {
          markAsDirty();
        }
      }
    }

    window.addEventListener('message', handleDirtyChange);
    return () => window.removeEventListener('message', handleDirtyChange);
  }, []);

  React.useEffect(() => {
    if (selectGlobalShadow && selectedShadow) {
      selectGlobalShadow(selectedShadow);
    }
  }, [selectedShadow]);

  async function handleExit() {
    try {
      if (dirty) {
        await confirm('There are unsaved changes - are you sure you want to leave this grid?', {
          buttonLabel: 'Leave Grid',
          buttonStyle: 'danger',
          title: 'Unsaved Changes',
        });
      }
      if (selectGlobalShadow) {
        selectGlobalShadow(null);
      }
      setDirtyTab(false);
      selectShadow(null);
    } catch (error) {
      // Confirmation canceled
    }
  }

  return (
    <Editor
      canExportShadows={canExportShadows}
      context={context}
      path={urls.index}
      shadow={selectedShadow}
      shadowInputOverridesUrl={urls.inputOverrides}
      shadowStylesheetUrl={urls.styles}
      onExit={handleExit}
    />
  );
}

ShadowEditor.propTypes = {
  canExportShadows: PropTypes.bool,
  context: PropTypes.object,
  markAsDirty: PropTypes.func.isRequired,
  selectedShadow: PropTypes.object,
  selectGlobalShadow: PropTypes.func,
  selectShadow: PropTypes.func.isRequired,
  setDirty: PropTypes.func.isRequired,
  urls: PropTypes.object
};

const mapStateToProps = state => ({
  canExportShadows: state.canExportShadows,
  context: state.context,
  selectedShadow: state.shadows.selected,
  urls: state.urls,
});

const mapDispatchToProps = {
  markAsDirty,
  selectShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShadowEditor);
